"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleGtmValidationError = exports.modifyFormData = exports.performReCaptchaCheck = exports.shouldRenderControl = exports.handleError = exports.updateInitialFormValues = exports.ErrorType = void 0;
const app_1 = require("app");
const SignUpFormConfig_1 = require("Views/Partials/Components/SignUp/SignUpFormConfig");
const Forms_1 = require("Forms");
var ErrorType;
(function (ErrorType) {
    ErrorType["validationError"] = "Front-end validation error";
    ErrorType["serverError"] = "Back-end error";
    ErrorType["countryValidationError"] = "Front-end validation embargo country error";
})(ErrorType || (exports.ErrorType = ErrorType = {}));
const updateInitialFormValues = (props, initialFormState) => {
    Object.values(props.inputObject)
        .filter(({ defaultValue }) => defaultValue)
        .forEach(({ name, defaultValue }) => {
        initialFormState[String(name)] = defaultValue;
    });
    return initialFormState;
};
exports.updateInitialFormValues = updateInitialFormValues;
const handleError = (gtmData, renderMessage, specificFields) => {
    const { errorMessageTitleText, errorMessageText } = specificFields;
    app_1.GTM.newsletter.error(Object.assign(Object.assign({}, gtmData), { errorType: ErrorType.serverError }));
    renderMessage(errorMessageTitleText, errorMessageText);
};
exports.handleError = handleError;
const shouldRenderControl = (formControl, props, formState) => {
    if (formControl.key === SignUpFormConfig_1.formControlKeys.language) {
        const { languages } = props.items;
        if (!shouldRenderLanguage(formState, languages)) {
            return false;
        }
    }
    return true;
};
exports.shouldRenderControl = shouldRenderControl;
const shouldRenderLanguage = ({ country }, languages) => {
    return Boolean(country && languages && languages[country]);
};
const performReCaptchaCheck = (recaptchaRef, renderMessage, specificFields) => {
    const captchaEl = recaptchaRef.current;
    const reCaptchaInitialized = captchaEl.getWidgetId() !== null;
    const { errorMessageTitleText, errorMessageText } = specificFields;
    if (reCaptchaInitialized) {
        captchaEl.execute();
    }
    else {
        /*
          When recaptcha widget is not initialized due to network issues
          we send form with empty token. This should result with error response from BE.
        */
        renderMessage(errorMessageTitleText, errorMessageText);
    }
};
exports.performReCaptchaCheck = performReCaptchaCheck;
const modifyFormData = (data, modifiedData = {}) => {
    delete Object.assign(modifiedData, data, { ['userConsent']: data['consentCheckbox'] })['consentCheckbox'];
    return modifiedData;
};
exports.modifyFormData = modifyFormData;
const handleGtmValidationError = (isValidating, isSubmitting, gtmData, errors, values) => {
    if (isValidating && isSubmitting) {
        Object.keys(errors).forEach(field => {
            const errorType = field === 'country' && (0, Forms_1.validateCountry)(values.country)
                ? ErrorType.countryValidationError
                : ErrorType.validationError;
            app_1.GTM.newsletter.error(Object.assign(Object.assign({}, gtmData), { errorType: errorType, errorField: field }));
        });
    }
};
exports.handleGtmValidationError = handleGtmValidationError;
